import { render, staticRenderFns } from "./LojaSearchSelect.vue?vue&type=template&id=6a0f6b70"
import script from "./LojaSearchSelect.js?vue&type=script&lang=js&external"
export * from "./LojaSearchSelect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports